export enum DataExtractionType {
  none = 0,
  fixed = 1,
  fileLayout = 2,
  batchFileLayout = 3
}
